export type UrlInfo = {
    origin: string;
    paths: ReadonlyArray<string | number>;
    searchParams?: Record<string, string | number>;
};

export const createURL = ({ origin, paths, searchParams }: UrlInfo) => {
    const url = new URL(origin);
    if (paths.length) {
        if (!url.pathname.endsWith('/')) {
            url.pathname += '/';
        }
        url.pathname += paths.join('/');
    }
    if (searchParams) {
        const urlSearchParams = new URLSearchParams(
            Object.entries(searchParams).map(([k, v]) => [k, v.toString()])
        );
        urlSearchParams.forEach((value, name) => {
            url.searchParams.append(name, value);
        });
    }
    return url.href;
};
